import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store'
import { AppRouter } from './router'
import { ToastProvider } from './components/ui'

export default function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        {/* Above the router so the booking wizard, which renders outside the
            app shell, can raise toasts too. */}
        <ToastProvider>
          <AppRouter />
        </ToastProvider>
      </BrowserRouter>
    </Provider>
  )
}
